<template>
  <!-- 教育资助缴费 -->
  <div class="white_back">
    <div class="bindStudent">
      <div class="top">
        <div class="boxd">
          <img :src="logo" alt />
        </div>
        <img class="rightLogo" src="../../assets/img/eduSelfLogo.png" alt />
      </div>
      <div class="companyname">{{ sponsor ? sponsor : "北京博思致新互联网科技有限责任公司" }}</div>
      <div class="center">
        <van-form>
          <div>
            <div class="fieldBox">
              <img src="../../assets/img/selfEduname.png" alt />
              <van-field  v-model="name" :placeholder="'请输入'+(nameField?nameField.showName:'学生姓名')" />
            </div>

            <div class="fieldBox">
              <img src="../../assets/img/wxcard.png" alt />

              <van-field maxlength="25" v-model="card"  :placeholder="'请输入'+ (idCardField?idCardField.showName:'证件号码')" />
            </div>

            <div class="fieldBox" v-if="verificationShow">
              <img src="../../assets/img/wxphone.png" alt />

              <van-field
                  v-model.trim="phone"
                  ref="phone"
                  @change="phonechange"
                  maxlength="18"
                  :placeholder="'请输入'+(phoneField?phoneField.showName:'手机号码')"
              />
            </div>

            <div v-if="verificationShow" class="fieldBox">
              <img src="../../assets/img/wxyzm.png" alt />
              <van-field
                  maxlength="6"
                  :class="disabledShow?'novarify':'varify'"
                  v-model.trim="code"
                  name="验证码"
                  placeholder="请输入验证码"
              />
              <div class="getVari">
                <span v-if="disabledShow" @click="getVerification">获取验证码</span>
                <span v-else>{{ timer }}s后重新获取</span>
              </div>
            </div>
          </div>
        </van-form>
        <div class="rememberpsd">
          <van-checkbox v-model="isRememberPassword">记住查询信息</van-checkbox>
        </div>
        <div style=" text-align: center">
          <van-button native-type="submit" @click="sub" class="bindBtn">
            下一步
            <img class="blueSha" src="../../assets/img/blueshadow.png" alt />
          </van-button>
        </div>
        <div class="pri">
          <van-checkbox v-model="isRead" shape="square" label-disabled>
            <span @click="isRead = !isRead">勾选即代表我已阅读并同意</span>
            <span @click="toNotice">《用户隐私政策》</span>
          </van-checkbox>
        </div>
        <div class="noReg">
          新生首次登录，请点击“注册”并完善学生基础信息
          <!-- <span @click="goRegister">注册</span> -->
          <div class="regBtn" @click="goRegister">注册&nbsp;→</div>
        </div>
        <!-- color更多字体颜色 -->
        <!-- state使用什么颜色的喇叭 1-绿色  2-蓝色 -->

        <!-- <Foot
        v-if="isOriginHeight&&list && list.bottomMessage && list.bottomMessage.length > 0"
        :list="list"
        ></Foot>-->
      </div>
      <ErrorNotice @close="showErr = false" :show="showErr" :notice="notice"></ErrorNotice>
    </div>
    <CustomFoot :typeName="'1'" :isHome="true" class="zdyfooter" color="#297bf4" state="2">
      <div class="btn_shadow notice_box_foot">
        确认
        <span></span>
      </div>
    </CustomFoot>
  </div>
</template>

<script>
import "vant/lib/index.css"
import Logo from "@/components/logo"
import { judgeVde } from "@/utils/publicJudge"
import { Dialog, Toast } from "vant"
import PrivacyDialog from "@/components/dialog/privacyDialog"
import { savePrivacy } from "@/utils/common.js"
import NoticeDialog from "../noticePublic/noticeDialog.vue"
import Foot from "@/components/foot"
import ErrorNotice from "@/components/dialog/errorNotice"
import CustomFoot from "@/components/customFoot"

// 全局注册
export default {
  data() {
    return {
      sponsor: "",
      notice: "",
      showErr: false,
      checkRead: false,
      screenHeight: document.documentElement.clientHeight, // 当前高度
      originHeight: document.documentElement.clientHeight, //默认高度，用作比较
      isOriginHeight: true, //当前高度是否仍等于默认高度,
      name: "",
      card: "",
      nameField:null,
      idCardField:null,
      phoneField:null,
      agree: false, // 是否允许提交的标识
      show: false, // 正则提示是否显示标识
      sheel: true,
      deptList: [],
      deptNameList: [],
      showChooseDept: false, // 控制选择单位注册的弹窗是否显示
      vde: "",
      logo: "",
      list: {},
      bgColor: "#0091ff",
      isRead: "",
      details: [],
      phone: "",
      code: "",
      showD: false,
      phoneShow: false,
      verificationShow: false,
      timer: 60,
      disabledShow: true,
      fieldList:[],
      s:'',
      isRememberPassword:false
    }
  },
  watch: {
    screenHeight(val) {
      if (this.originHeight - val > 60) {
        //这里以防万一改了下判断形式，当屏幕高度减少了60px以上时才隐藏footer
        this.isOriginHeight = false
      } else {
        this.isOriginHeight = true
      }
    }
  },
  activated() {
    // console.log(this.$route.query?.isRead);
    let state = this.$route.query?.isRead
    this.isRead = state == 1 ? true : false
    if (this.isRead) {
      this.sub()
    }
  },
  created() {
    localStorage.setItem('sysType','1')
    localStorage.setItem('scene','')

    if (this.$route.query.vde === undefined) {
      this.vde = ""
    } else {
      this.vde = this.$route.query.vde
    }
    this.s = this.$route.query.s ? this.$route.query.s : ""
    if (this.s) {
      let queryInfo = JSON.parse(this.$route.query.s)
      this.vde = queryInfo.vde
    }
    //判断vde
    judgeVde({ vde: this.vde }, this)
    // 清除缓存
    if (sessionStorage.getItem("info")) {
      sessionStorage.removeItem("info")
    }
    if (sessionStorage.getItem("out")) {
      sessionStorage.removeItem("out")
    }
    if (sessionStorage.getItem("gradeAddClassInfo")) {
      sessionStorage.removeItem("gradeAddClassInfo")
    }
    localStorage.removeItem("fromEdu")
    // 进来之后获取一次头部和底部信息
    this.getFooterData()
    let isWx = this.isWx()
    this.getHeadImg()
    if (isWx) {
      //在微信中打开
      let isWxCode = this.$route.query?.code
      let vde = localStorage.getItem("vde")
      let url = window.location.href
      if (isWxCode) {
        //重定向后的地址
        this.getOpenIdByCode({ code: isWxCode, vde: vde })
      } else {
        //没有code参数 为第一次进入
        this.getWxAuthorizeUrl({ redirectUri: url, deptId: vde })
      }
      if (localStorage.getItem(this.vde + "opendID")) {
        this.openid = localStorage.getItem(this.vde + "opendID")
      }
    } else {
      this.openid = ""
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenHeight = document.documentElement.clientHeight
      })()
    }
    this.verification()
    if(localStorage.getItem('rememberPassword')){
      let obj  = JSON.parse(localStorage.getItem('rememberPassword')) || null
      if(obj){
        this.isRememberPassword = true
        this.name = obj.name
        this.card = obj.card
        this.phone = obj.phone
      }
    }


  },
  methods: {
    toNotice() {
      this.$router.push({
        path: "/selfEdu/notice",
        query: {
          person: "1",
          headerText: "通知"
        }
      })
    },
    getVerification() {
      if (this.phone.length > 0 && this.phoneShow == false) {
        let obj = {
          name: this.name,
          idCard: this.card,
          phone: this.phone,
          type: "1",
          vde: this.vde
        }
        this.request({
          baseURL: process.env.VUE_APP_PAY_URL,
          url: `/sms/sendVerifiCodeQuery`,
          method: "post",
          data: obj
        }).then((res) => {
          // console.log(res)
          if (res.data.code == 1000) {
            Toast({ message: res.data.message, icon: "none" })
            //
            this.disabledShow = false
            const authTimer = setInterval(() => {
              this.timer--
              if (this.timer <= 0) {
                this.disabledShow = true
                this.timer = 60
                clearInterval(authTimer)
              }
            }, 1000)
          } else {
            Toast({ message: res.data.message, icon: "none" })
          }
        })
      } else {
        if (this.phone.length == 0)
          Toast({ message: "手机号码不能为空", icon: "none" })
        if (this.phoneShow == true)
          Toast({ message: "手机号码格式错误", icon: "none" })
      }
    },
    verification() {
      this.request({
        baseURL: process.env.VUE_APP_BASE_URL,
        url: `/payPhoneInput/verification`,
        method: "get",
        params: {
          vde: this.vde
        }
      }).then((res) => {
        // console.log(res)
        if (res.data.code == 1000) {
          this.verificationShow = res.data.result
          let messageFlag=false;
          // 获取接口字段
          if(this.verificationShow){
            // 短信打开就多加个参数
            messageFlag=true;
          }else{
            // 否则就不多加
            messageFlag=false;
          }
          this.request({
            url:'/education/h5/self/field',
            method:'get',
            params:{
              vde:this.vde,
              messageFlag
            }
          }).then(res=>{
            // console.log(res)
            if(res.data.code==1000){
              if(res.data.result){
                this.fieldList=res.data.result;
                this.fieldList.forEach(item=>{
                  if(item.fieldName=='name'){
                    this.nameField=item;
                  }
                  if(item.fieldName=='idCard'){
                    this.idCardField=item;
                  }
                  if(item.fieldName=='phone'){
                    this.phoneField=item;
                  }
                })
              }
            }else{
              this.$CDialog({
                confirmBtnText: "确认",
                title: "提示",
                message: res.data.message,
                status: "2",
                textSize: "16"
              })
            }
          })
        }
      })
    },
    getWxAuthorizeUrl(obj) {
      let { deptId } = obj
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: `/wx/getWxAuthorizeUrl?deptId=${deptId}&redirectUri=${encodeURIComponent(
            `/selfEdu`
        )}&type=01`,
        method: "post"
      }).then((res) => {
        if (res.data.code === 1000) {
          console.log(res.data)
          window.location = res.data.result.authorizeUrl
          localStorage.setItem("appId", res.data.result.appId)
          // window.location = res.data.message
        }
      })
    },
    phonechange() {
      let reg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (this.phone.length) {
        if (reg.test(this.phone)) {
          this.phoneShow = false
        } else {
          this.phoneShow = true
        }
      } else {
        this.phoneShow = false
      }
    },
    getOpenIdByCode(obj) {
      let { code, vde } = obj
      let appId = localStorage.getItem("appId")
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: `/wx/getOpenIdByAppId?code=${code}&appId=${appId}`,
        method: "post"
      }).then((res) => {
        if (res.data.code === 1000) {
          this.openid = res.data.result
          //成功后保存到浏览器缓存
          localStorage.setItem(this.vde + "opendID", res.data.result)
        }else{
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            message: res.data.message,
            status: "2",
            textSize: "16"
          })
        }
      })
    },
    isWx() {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1 //通用
    },
    closeO() {
      this.showD = false
    },
    getReadState(isRead, details, type) {
      this.isRead = isRead
      this.details = details
    },
    goNextAction(isRead, details, type) {
      this.isRead = isRead
      this.details = details
      if (type == 1) {
        this.sub()
      }
    },
    // 存储隐私授权接口
    savePrivacy() {
      let data = {
        details: this.details,
        userId: this.name,
        userName: this.card
      }
      savePrivacy(data)
    },
    getHeadImg() {
      let data = {}
      data.vde = this.vde
      this.request({
        url: "/webPortal/websitConfig",
        method: "get",
        params: data
      }).then((res) => {
        if (res.data.code == 1000) {
          if (res.data.result == null) {
            this.logo = require("@/assets/img/logo.png")
            return
          }
          if (res.data.result.logoUrl) {
            this.logo = res.data.result.logoUrl
          } else {
            this.logo = require("@/assets/img/logo.png")
          }
          if (res.data.result.logoName) {
            this.sponsor = res.data.result.logoName
          }
        } else if (res.data.code != 1000) {
          this.$router.push({ path: "/404" })
        }
      })
    },
    // getHeaderLogo() {
    //   let param = {};
    //   param.vde = this.vde;
    //   this.request({
    //     url: "/webPortal/websitConfig",
    //     method: "get",
    //     params: param,
    //   }).then((res) => {
    //     if (res.data.code == 1000) {
    //       // 先判断是否有logo，有的话则设置给logo
    //       if (res.data.result.logoUrlLogin) {
    //         this.logo = res.data.result.logoUrlLogin
    //           ? res.data.result.logoUrlLogin
    //           : "@/assets/img/zft.png";
    //       } else {
    //         this.logo = "@/assets/img/zft.png";
    //       }
    //     } else {
    //       this.$router.push({ path: "/404" });
    //     }
    //   });
    // },
    getFooterData() {
      let data = {
        vde: this.vde,
        type: 1
      }
      this.request({
        url: "/systemManage/mobileGetMessage",
        method: "get",
        params: data
      }).then((res) => {
        if (res.data.code != 1000) {
          this.$router.push({ path: "/404" })
        } else {
          this.list = res.data.result
        }
      })
    },
    goRegister: function () {
      sessionStorage.removeItem("info")
      // 去选择学校的页面
      this.$router.push({
        path: "/selfEdu/selSchool",
        query: {
          vde: this.vde
        }
      })
      // if (this.deptList.length <= 0) {
      //   this.request({
      //     url: "/prepaid/listEduDept",
      //     method: "get",
      //     params: { vde: this.vde },
      //   }).then((res) => {
      //     this.deptList = [];
      //     this.deptNameList = [];
      //     if (res.data.code == 1000) {
      //       this.deptList = res.data.result;
      //       const list = [];
      //       this.deptList.forEach((dept) => {
      //         list.push(
      //           '<span class="deptIdName">' +
      //             dept.deptName +
      //             '</span><br><span class="deptIdBox">' +
      //             dept.deptId +
      //             "</span>"
      //         );
      //       });
      //       this.deptNameList = list;
      //       this.showChooseDept = true;
      //       // setTimeout(() => {
      //       //   $(".van-ellipsis").each((i, val) => {
      //       //     if ($(val).html().length > 20) {
      //       //       var scrollWidth = $(val).parent().width()
      //       //       var textWidth = $(val).width()
      //       //       var i = scrollWidth
      //       //       setInterval(function () {
      //       //         i--
      //       //         if (i < -textWidth) {
      //       //           i = scrollWidth
      //       //         }
      //       //         $(val).animate({ left: i + "px" }, 10)
      //       //       }, 20)
      //       //       $(val).css({ position: "relative", "white-space": "nowrap" })
      //       //       $(val).removeClass("van-ellipsis")
      //       //     }
      //       //   })
      //       // }, 0)
      //     } else {
      //       Dialog.alert({
      //         title: "提示",
      //         message: res.data.message,
      //       }).then(() => {});
      //       this.showChooseDept = false;
      //     }
      //   });
      // } else {
      //   this.showChooseDept = true;
      // }
    },
    // 选择单位点确定
    onDeptConfirm: function (value, index) {
      this.showChooseDept = false
      if (index + 1 > this.deptList.length) {
        Toast.clear()
        // Dialog.alert({
        //   title: "提示",
        //   message: "获取单位出错，请刷新后重试",
        // }).then(() => {});
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          message: "获取单位出错，请刷新后重试",
          status: "2",
          textSize: "12"
        })
        return false
      }
      const dept = this.deptList[index]
      //跳转到注册页面
      this.$router.push({
        path:
            "/pages/prepaid/registerPro?deptId=" +
            dept.deptId +
            "&deptName=" +
            dept.deptName +
            "&vde=" +
            this.vde
      })
    },
    // 选择单位点取消
    onDeptCancel: function () {
      this.showChooseDept = false
    },

    check() {
      // update by xgj on 2022/2/11 证件号码这里不做限制，用户输入什么查询什么
      // var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      var user = this.name.replace(/(^\s*)|(\s*$)/g, "")
      var card = this.card.replace(/(^\s*)|(\s*$)/g, "")
      var code = this.code.replace(/(^\s*)|(\s*$)/g, "")

      if (user.length == 0) {
        // console.log(123);
        // Toast({ message: "学生名字不能为空", icon: "none" });
        // this.showErr = true
        // this.notice = "学生名字不能为空"
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: '学生名字不能为空',
        }).then((res) => {
        });
        return
      } else if (card.length == 0) {
        // this.show = true;
        // this.showErr = true
        // this.notice = "证件号码不能为空"
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: '证件号码不能为空',
        }).then((res) => {
        });
        return
      } else {
        this.agree = true
        this.show = false
        // update by xgj on 2022/2/11 证件号码这里不做限制，用户输入什么查询什么
        /*if (!reg.test(this.card)) {
          // console.log("身份证输入不合法");
          this.show = true;
          this.agree = false;
          Toast({
            message: "身份证号码填写有误",
            icon: "none",
          });
          return false;
        } else {
          this.agree = true;
          this.show = false;
        }*/
      }
      if (this.verificationShow && code.length == 0) {
        this.agree = false
        // Toast({ message: "验证码不能为空", icon: "none" });
        // this.showErr = true
        // this.notice = "验证码不能为空"
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: '验证码不能为空',
        }).then((res) => {
        });
        return
      }
    },
    sub() {

      this.check()
      if (!this.agree) {
        return
      }
      // if (this.isRead == false) {
      //   this.$refs.privacyDialog.open();
      //   return;
      // }
      if (this.isRead == false) {
        // this.$refs.privacyDialog.open();
        this.$router.push({
          path: "/selfEdu/notice",
          query: {
            person: "1",
            headerText: "通知"
          }
        })
        return
      }
      if (this.agree) {
        // 先去后端获取数据然后保存在sessionStorage
        // /prepaid/getEduAutoStudent	POST
        // 直接在 跳转之前，将数据保存给sessionStorage
        this.request({
          url: "/prepaid/getEduAutoStudent",
          method: "post",
          data: {
            name: this.name,
            idCard: this.card,
            vde: this.vde,
            phone: this.phone,
            type: this.verificationShow ? "1" : "",
            verifyCode: this.code,
            wxOpenId: localStorage.getItem(this.vde + "opendID") || ""
          }
        }).then((res) => {
          // console.log(res.data)
          if (res.data.code == 1000) {
            sessionStorage.setItem("info", JSON.stringify(res.data.result))
            if (sessionStorage.getItem("out")) {
              sessionStorage.removeItem("out")
            }
            this.savePrivacy()
            if(this.isRememberPassword){
              let obj = {
                name:this.name,
                card:this.card,
                phone:this.phone,
              }
              localStorage.setItem('rememberPassword',JSON.stringify(obj))
            }else{
              localStorage.setItem('rememberPassword','')
            }
            this.$router.push({
              path: "/paymain",
              query: {
                name: res.data.result.name,
                idCard: res.data.result.idCard,
                vde: this.vde
              }
            })
          } else {
            Toast({ message: res.data.message, icon: "none" })
          }
        })
      }
    },
    showpass() {
      if (this.sheel) {
        this.sheel = false
        // console.log(this.$refs);
        this.$refs.sfz.type = "text"
        this.$refs.eye.style = "opacity:1"
      } else {
        this.sheel = true
        // console.log(this.$refs);
        this.$refs.sfz.type = "password"
        this.$refs.eye.style = "opacity:1"
      }
    }
  },
  components: {
    Logo,
    Foot,
    PrivacyDialog,
    NoticeDialog,
    ErrorNotice,
    CustomFoot
  }
}
</script>
<style lang="scss" scoped>
.white_back {
  min-height: 100vh;
  background: #fff;
}
.bindStudent {
  background: url("../../assets/img/backi.png") no-repeat;
  background-size: 110% 120%;
  ::v-deep .van-cell {
    padding-left: 0px !important;
  }
  .companyname {
    ;
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: bold;
    text-align: left;
    margin-bottom: 16px;
    padding-left: 26px;
  }
  .top {
    height: 148px;
    display: flex;
    align-items: flex-end;
    .boxd {
      width: 80px;
      height: 80px;
      background: #fff;
      border-radius: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 24px;
      margin-bottom: 10px;
      // todo logo
      > img {
        width: 79px;
      }
    }
    .rightLogo {
      display: block;
      width: 172px;
      height: 148px;
      margin: 0px auto;
    }
  }

  .center {
    // min-height: 54vh;
    margin-top: 10px;
    background: url("../../assets/img/blcard.png") no-repeat;
    background-size: 100% 110%;
    padding-top: 20px;
    .remarkBox {
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      height: 212px;
      width: 325px;
      margin: 14px auto;
      .boxTop {
        padding: 5px 10px;
        padding-top: 0px;
        display: flex;
        align-items: center;
        > img {
          width: 56px;
          height: 56px;
          margin-left: -10px;
        }
        .remkNotice {
          width: 255px;
          margin-left: 15px;
          margin-bottom: 10px;

          font-size: 16px;
          color: #464a4c;
          letter-spacing: 0;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          padding-right: 10px;
        }
      }
      .hr {
        width: 285px;
        margin: 0 auto;
        height: 1px;
        background: #f0f0f0;
        padding-left: 10px;
        padding-right: 10px;
        margin-top: -12px;
      }
      ::v-deep .van-field__control::-webkit-input-placeholder {

        font-size: 16px;
        color: rgba(70, 74, 76, 0.7);
        letter-spacing: 0;
        font-weight: 500;
      }
    }
    .fieldBox {
      ::v-deep input.van-field__control::-webkit-input-placeholder {

        font-size: 16px;
        color: rgba(70, 74, 76, 0.7);
        letter-spacing: 0;
        font-weight: 500;
      }
      margin: 14px auto;
      background: #fff;
      border-radius: 25px;
      width: 325px;
      height: 44px;
      display: flex;

      .wrap {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        padding: 0px 20px;
      }
      .wrapF {
        width: 325px;
        height: 212px;
        background: #fff;
        .wrap {

          font-size: 16px;
          color: #464a4c;
          letter-spacing: 0;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;
          padding: 0px 20px;
        }
      }
      img {
        width: 56px;
        height: 56px;
      }

      ::v-deep .van-field {
        width: 240px !important;
      }

      .novarify {
        width: 170px !important;
      }
      .varify {
        width: 150px !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .getVari {

        font-size: 16px;
        color: #208fff;
        letter-spacing: 0;
        font-weight: 500;
        line-height: 44px;
        // margin-left: 30px;
      }
    }
  }

  ::v-deep .footNotice {
    padding: 0px 20px;
  }

  ::v-deep .foot {
    margin-bottom: 0px !important;
  }
}

.bindBtn {
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  width: 326px;
  height: 50px;
  border-radius: 27px;
  font-size: 20px;
  color: #fff;
  font-weight: 700;

  color: #ffffff;
  letter-spacing: 0;
  font-weight: 700;
  position: relative;
  border: none !important;
  outline: none !important;
  ::v-deep .van-button::before {
    border: none;
  }
  .blueSha {
    width: 296px;
    height: 34px;
    position: absolute;
    left: 50%;
    top: 68%;
    transform: translateX(-50%);
  }
  // box-shadow: 0px 6px 2px #208FFF;
}

.pri {
  // margin:0 auto;
  // text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 0px;
  margin-left: -18px;
  // padding-left: 12px;
  span:nth-of-type(1) {

    font-size: 14px;
    color: #464a4c;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 400;
  }
  span:nth-of-type(2) {

    font-size: 14px;
    color: #208fff;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 700;
  }

  ::v-deep .van-checkbox__icon .van-icon {
    border-radius: 4px;
    border-color: #208fff;
  }
}
.noReg {
  margin-top: 13px;

  font-size: 12px;
  color: #464a4c;
  letter-spacing: 0;
  line-height: 18px;
  font-weight: 400;
  text-align: center;
  .regBtn {

    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 400;
    width: 75px;
    height: 24px;
    background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
    border-radius: 11.48px;
    margin: 0 auto;
    margin-top: 10px;
    line-height: 24px;
  }
  > span {

    font-size: 12px;
    color: #208fff;
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 700;
  }
}
.zdyfooter {
  margin-top: 30px !important;
  padding: 0px 28px;
}
.notice_box_foot {
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  border-radius: 22px;
  margin: 0 19px;
  height: 46px;
  line-height: 46px;

  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
}
.btn_shadow,
.notice_box_foot {
  position: relative;
  > span {
    position: absolute;
    width: 90%;
    background: url("../../assets/img/blueshadow.png") 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 0.58667rem;
    height: 0.96rem;
    left: 50%;
    margin-left: -45%;
    bottom: -19px;
    z-index: 0;
  }
}
.rememberpsd{
  padding-left: 24px;
  margin: 12px 0 20px 0;
  ::v-deep .van-checkbox__icon--round .van-icon{
    border-color: #208fff !important;
  }
}
</style>
